import React, { useCallback, useEffect, useState } from 'react';
import { svgSprite } from '../../../../hybrid/wrappers';
import css from './UpBtnNews.module.scss';

const UpBtnNews = ({}) => {
    const goTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const [show, setShow] = useState(false);
    const scroll = useCallback(() => {
        setShow(window.pageYOffset > 100);
    }, []);
    useEffect(() => {
        window.addEventListener('scroll', scroll);
        return () => {
            window.removeEventListener('scroll', scroll);
        };
    }, [scroll]);
    return (
        <>
            {show && (
                <div onClick={goTop} className={css.svgWrap}>
                    {svgSprite('arrow-up', {
                        width: 13,
                        height: 16,
                        fill: 'var(--darkColor)'
                    })}
                </div>
            )}
        </>
    );
};
export default UpBtnNews;
